var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3005 16.362C12.2614 14.6362 15.75 11.1105 15.75 7.875C15.75 6.08479 15.0388 4.3679 13.773 3.10203C12.5071 1.83616 10.7902 1.125 9 1.125C7.20979 1.125 5.4929 1.83616 4.22703 3.10203C2.96116 4.3679 2.25 6.08479 2.25 7.875C2.25 11.1105 5.7375 14.6362 7.6995 16.362C8.05738 16.6814 8.5203 16.858 9 16.858C9.4797 16.858 9.94262 16.6814 10.3005 16.362ZM6.75 7.875C6.75 7.27826 6.98705 6.70597 7.40901 6.28401C7.83097 5.86205 8.40326 5.625 9 5.625C9.59674 5.625 10.169 5.86205 10.591 6.28401C11.0129 6.70597 11.25 7.27826 11.25 7.875C11.25 8.47174 11.0129 9.04403 10.591 9.46599C10.169 9.88795 9.59674 10.125 9 10.125C8.40326 10.125 7.83097 9.88795 7.40901 9.46599C6.98705 9.04403 6.75 8.47174 6.75 7.875Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.39f3962b3caf2b4fe84563d72e0a0230.svg";
export { ForwardRef as ReactComponent };